import type { TrackedTeam } from "./api";

/** Epic accounts known to have impersonated a real pro's teammate.
 *
 *  When an impersonation slips through Epic's own checks, the board ends up
 *  with a ghost team entry (real pro + fake account) alongside the corrected
 *  real duo — both synthesise into cards, so the dashboard shows the same
 *  pairing twice. Epic fixes the points server-side but never retracts the
 *  ghost entry, and our journal keeps re-surfacing it.
 *
 *  This is a client-side bandaid: teams containing one of these accounts are
 *  dropped before render. The real fix is scrubbing the ghost entries from
 *  the persisted board data server-side. */
const IMPOSTOR_EPIC_IDS = new Set([
  // "АUR t3enу" (Cyrillic-homoglyph name) — impersonated T3eny in FNCS Major
  // 2 Play-Ins EU, 2026-07-18. Shxrk queued game 1 with this account before
  // Epic swapped in the real T3eny (e7987ee7…); the ghost "Shxrk + АUR t3enу"
  // board entry lives on at 0 points.
  "3b92b36f14ae49ae9066b3e53647f353",
]);

/** True if any member of this synthesised team is a known impostor. */
export function hasImpostor(team: TrackedTeam): boolean {
  return team.members.some(m => IMPOSTOR_EPIC_IDS.has(m.epic_id));
}
